var site = function () {

  var publicMethods = {};

	var body = document.querySelector('body');

  publicMethods.init = function() {

		header();
    mobileNav();
		images();
		skipSections();

  };

  function header() {

		var element = document.querySelector('.l-header');

		if (!element) return;

		var offset = 100;
		var isLarge = true;

		var check = function () {

			var scroll = window.scrollY;

			if (scroll <= offset && !isLarge) {

				element.classList.add('large');
				element.classList.remove('small');
				isLarge = true;

			} else if (scroll > offset && isLarge) {

				element.classList.remove('large');
				element.classList.add('small');
				isLarge = false;

			}

		};

		window.addEventListener('scroll', check);

  };

	function mobileNav() {

		var trigger = document.querySelector('#mobile-nav-trigger .js-trigger');
		var close = document.querySelector('#mobile-nav .js-nav-close');

		if (!trigger || !close) return;

		trigger.addEventListener('click', function(e) {

			body.classList.add('nav-open');
			e.preventDefault();

		});

		close.addEventListener('click', function(e) {

			body.classList.remove('nav-open');
			e.preventDefault();

		});

	};

	function images() {

		var backgroundImageElements = document.querySelectorAll('[data-custom-bg]');

		var observer = new IntersectionObserver(observerCallback, { rootMargin: "0px 0px 250px 0px" });

		function observerCallback(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {

					var targetElement = entry.target;

					var bg = targetElement.getAttribute('data-custom-bg');
					var bgMedium = targetElement.getAttribute('data-custom-bg-medium');
					var bgLarge = targetElement.getAttribute('data-custom-bg-large');

					if (bgMedium && window.matchMedia('(min-width: 400px)').matches) bg = bgMedium;
					if (bgLarge && window.matchMedia('(min-width: 1200px)').matches) bg = bgLarge;

					targetElement.style.backgroundImage = 'url(' + bg + ')';

					observer.unobserve(targetElement);
				}
			});
		};

		for (var i = 0; i < backgroundImageElements.length; i++) {
			observer.observe(backgroundImageElements[i]);
		}

	};

	function skipSections() {

		var links = document.querySelectorAll('.js-skip-section');

		if (!links.length) return;

		for (var i = 0; i < links.length; i++) {
			
			(function (i) {
				
				links[i].addEventListener('click', function() {

					focusNextElement(links[i].getAttribute('data-skip'));
					e.preventDefault();

				});

			})(i);
		
		}

	};

	function focusNextElement(excludedSelector) {

		// add all elements we want to include in our selection
		var focussableElements = 'a:not([disabled]):not(' + excludedSelector + '), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
		if (document.activeElement) {
			var focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements),
				function (element) {
					// check for visibility while always include the current activeElement 
					return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
				});
			var index = focussable.indexOf(document.activeElement);
			if (index > -1) {
				var nextElement = focussable[index + 1] || focussable[0];
				nextElement.focus();
			}
		}

	};

  return publicMethods;

}();

site.init();